
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError
} from '../common/client/sagas/common';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const KNDATA_OPERATION_ACTION_TYPE = createActionTypes('knData/OPERATION');
export const KNDATA_GET_ACTION_TYPE = 'knData/GET';

export default function getActions(dispatch) {
    return {
        get: (token, projectId) => dispatch({
            type: KNDATA_GET_ACTION_TYPE, operation: 'GET', token, projectId
        })
    };
}

function knData(serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'knData',
            token: action.token,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workKnDataGet(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: KNDATA_OPERATION_ACTION_TYPE.DEFAULT});
        const data = yield call(knData, options.serverApi, action);
        yield put({type: KNDATA_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, KNDATA_OPERATION_ACTION_TYPE);
    }
}

export function* watchKnDataGet(options) {
    yield takeEvery(KNDATA_GET_ACTION_TYPE, workKnDataGet, options);
}
